<script setup lang="ts">
import type { RecentListItem } from '../composables/useRecentValues'

const props = withDefaults(
  defineProps<{
    items: RecentListItem[]
    label?: string
    currentValue?: RecentListItem | null
    formatLabel?: (value: RecentListItem) => string
  }>(),
  {
    label: 'Recent',
    currentValue: null,
    formatLabel: undefined,
  }
)

const emit = defineEmits<{
  select: [value: RecentListItem]
  remove: [value: RecentListItem]
}>()

function displayLabel(v: RecentListItem): string {
  return props.formatLabel ? props.formatLabel(v) : String(v)
}

function isActive(v: RecentListItem): boolean {
  if (props.currentValue === null || props.currentValue === undefined) return false
  return Object.is(props.currentValue, v)
}

function onRemove(v: RecentListItem, event: Event) {
  event.stopPropagation()
  emit('remove', v)
}
</script>

<template>
  <div v-if="items.length > 0" class="flex flex-wrap items-center gap-1.5">
    <div class="flex items-center gap-1 text-[11px] text-gpx_gray-300">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="h-3 w-3">
        <path
          fill-rule="evenodd"
          d="M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm7.75-4.25a.75.75 0 0 0-1.5 0V8c0 .414.336.75.75.75h3.25a.75.75 0 0 0 0-1.5h-2.5v-3.5Z"
          clip-rule="evenodd"
        />
      </svg>
      <span>{{ label }}:</span>
    </div>
    <button
      v-for="(v, idx) in items"
      :key="`${typeof v === 'number' ? 'n' : 's'}:${String(v)}:${idx}`"
      type="button"
      class="inline-flex items-center gap-0.5 rounded-full border px-2 py-0.5 text-[11px] transition-colors"
      :class="
        isActive(v)
          ? 'border-gpx_terracotta-100 bg-gpx_terracotta-900 text-gpx_terracotta-100'
          : 'border-gray-200 bg-white text-gpx_gray-200 hover:border-gpx_terracotta-300 hover:text-gpx_terracotta-100'
      "
      @click="emit('select', v)"
    >
      {{ displayLabel(v) }}
      <span class="ml-0.5 hover:text-red-500" @click.stop="onRemove(v, $event)">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="currentColor" class="h-2.5 w-2.5">
          <path
            d="M3.97 3.03a.75.75 0 0 1 1.06 0L6 4.94l.97-.97a.75.75 0 1 1 1.06 1.06L7.06 6l.97.97a.75.75 0 0 1-1.06 1.06L6 7.06l-.97.97a.75.75 0 0 1-1.06-1.06L4.94 6l-.97-.97a.75.75 0 0 1 0-1.06Z"
          />
        </svg>
      </span>
    </button>
  </div>
</template>
